/**
 * Federation Bot Avatar — SFUI-004 Spectral Overlay System
 * 
 * Single base bot image with CSS filter overlays for role differentiation:
 * - BLUE (default): Tour/Operator Bots (Rex, Oracle, Aria)
 * - PURPLE: Records/Library Bots (KEYS, Xavier)  
 * - RED: Truth/Restricted Bots (Agent Zero)
 * - GOLD: Token/Commerce Bots
 */

const BOT_BASE = "https://nextxus.online/avatars/bot-base.jpg";

const SPECTRAL = {
  blue:    { filter: 'none', label: 'Tour/Operator' },
  purple:  { filter: 'hue-rotate(270deg) saturate(1.2)', label: 'Records/Library' },
  red:     { filter: 'hue-rotate(330deg) saturate(1.8) brightness(0.7)', label: 'Truth/Restricted' },
  gold:    { filter: 'hue-rotate(45deg) saturate(1.5) brightness(1.1)', label: 'Token/Commerce' },
  magenta: { filter: 'hue-rotate(300deg) saturate(1.4) brightness(0.95)', label: 'Recycler/Entropy' },
  emerald: { filter: 'hue-rotate(120deg) saturate(1.3) brightness(1.05)', label: 'Mirror/Storage' },
};

// Map persona names to spectral class
const PERSONA_SPECTRAL = {
  rex: 'blue', oracle: 'blue', aria: 'blue',
  keys: 'purple', xavier: 'purple', scholar: 'purple',
  'agent zero': 'red', 'agent-zero': 'red',
  store: 'gold', commerce: 'gold', token: 'gold',
  recycler: 'magenta', 'the recycler': 'magenta',
  geminus: 'emerald', mirror: 'emerald',
};

export function BotAvatar({ persona, spectral, size = 'md', className = '', onClick, 'data-testid': testId }) {
  const color = spectral || PERSONA_SPECTRAL[persona?.toLowerCase()] || 'blue';
  const spec = SPECTRAL[color];
  
  const sizes = {
    xs: 'w-5 h-5',
    sm: 'w-7 h-7',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20',
    hero: 'w-28 h-28',
  };

  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 ${sizes[size]} ${className}`}
      onClick={onClick}
      data-testid={testId || `bot-avatar-${persona || color}`}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <img
        src={BOT_BASE}
        alt={`${persona || spec.label} Bot — NextXus Federation`}
        className="w-full h-full object-cover"
        style={{ filter: spec.filter }}
        loading="lazy"
      />
    </div>
  );
}

export { BOT_BASE, SPECTRAL, PERSONA_SPECTRAL };
export default BotAvatar;
